
import { useContext, useState } from 'react'
import { StoreContextMain } from '../../../Context/StoreContextMain'
import { CiShoppingCart } from 'react-icons/ci'
import { alertDialog, alertError, alertToast } from '../../../Helpers/Alerts'
import { useChekingAuth } from '../../../Auth'
import { useNavigate } from 'react-router-dom'
import { createOrder, addOrderItem, getOrder } from '../helpers'
import { jwtDecode } from 'jwt-decode'

/**
 * Este componente es un botón que se encarga de agregar un producto al carrito de compras.
 * @param {string} id
 * @param {string} title
 * @param {string} description
 * @param {number} price
 * @param {string} image
 * @param {string} text_aditional
 * @returns {JSX.Element}
 */

export const BtnAddCar = ({ id, title, description, price, image, text_aditional = '' }) => {

  const { store, setStore, selectedCharacteristics : feature } = useContext(StoreContextMain)
  
  const { logged } = useChekingAuth();

  const navigate = useNavigate()

  const [stateAdd, setStateAdd] = useState(false);

  const addCar = () => {
    // Validaciones de los campos requeridos
    if(!logged) return alertDialog('Primero necesitas iniciar sesión o registrarte', 'Ir', 'Cancelar').then(res => res ? navigate('/my-account') : false)

    if (id === null || id === '' || id === undefined) return alertError('Producto no disponible', 'No se ha encontrado el producto disponible');

    let color = feature.color ?? null
    let size = feature.size ?? null
    let amount = feature.amount ?? null
    let amount_max = feature.amount_max ?? null

    if (color === null || color === '') return alertError('Seleciona el color', 'No se ha selecionado el color');
    if (size === null || size === '') return alertError('Seleciona el tamaño', 'No se ha seleccionado el tamaño');
    if (amount === null || amount === 0) return alertError('Seleciona la cantidad', 'No se ha selecionado la cantidad');


    // Crear la orden y agregar el producto
    createOrderAndAddItem()
  }

  // Crear la orden y agregar el producto
  const createOrderAndAddItem = async () => {
    try {
      // Obtener el token del usuario
      const token = JSON.parse(localStorage.getItem('user_store_ecommerce'));
      if (!token) {
        // Si no se ha encontrado el token, logout
        localStorage.removeItem('user_store_ecommerce');
        window.location.href = '/my-account';
        throw new Error("Token de usuario no encontrado");
      }

      const decoded = jwtDecode(token)
      const userId = decoded?.user_id;
      if (!userId) throw new Error("ID de usuario no válido");

      let order;
      //Obtener la orden del usuario
      const orderData = await getOrder(userId)
      console.log("orderData", orderData);
      order = orderData?.results?.length > 0 ? orderData.results[0] : await createOrder(userId);
      console.log("order", order);
      if (!order?.uuid) throw new Error("No se ha podido obtener o crear la orden");

      // Agregar el producto a la orden
      const order_item = await addOrderItem(order.uuid, feature.productCategory?.uuid);

      if (!order_item) {
        alertError('Ha ocurrido un error', 'No se ha podido agregar el producto al carrito');
        return;
      }

      // Extraer datos del producto
      const {category, price, quantity} = order_item;
      const {product_uuid, product_name, product_image, stock} = category || {};

      let item = {
        id: product_uuid,
        title: product_name,
        price: price,
        image: product_image?.length ? product_image[0].image : '',
        color: '',
        size: '',
        amount: quantity,
        amount_max: stock,
      };

      // Obtener el color y la talla del producto
      if (category?.category) {
        const attributes = category.category.reduce((acc, attr) => {
          if (attr.category === "Colores") acc.color = attr.name;
          if (attr.category === "Tallas") acc.size = attr.name;
          return acc;
        }, {});
  
        item = { ...item, ...attributes };
      }    

      // Agregar el producto al carrito y actualizar estado
      setStore([...store, item]);
      setStateAdd(!stateAdd);
      alertToast('Producto agregado al carrito', 'success', 'start');
      
    } catch (error) {
      console.error(error);
      alertError('Ha ocurrido un error', error.message || 'No se ha podido completar la operación');    
    }

  }

  return (
    <button
        className={`car  ${text_aditional && 'd-flex btn btn-primary '}`}
        onClick={addCar}
    >
        <CiShoppingCart
          size={'2rem'}
          className={text_aditional && 'me-2'}
          style={{ color: stateAdd ? 'green' : 'var(--cafe-oscuro)'}}
        />
        {text_aditional}
    </button>
  )
}

